export default __webpack_public_path__ + "static/media/upt_sigmaharness_2.771b0489.jpeg";